(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hlg-home-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hlg-range-hero')) {
    customElements.define('hlg-range-hero', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        const buttons = [...this.querySelectorAll('[data-range]')];
        const select = button => {
          buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
          this.querySelectorAll('[data-scene]').forEach(scene => { scene.hidden = scene.dataset.scene !== button.dataset.range; });
          this.querySelector('.hlg-hero__intro').textContent = button.dataset.intro;
          const cta = this.querySelector('.hlg-hero__primary');
          cta.href = button.dataset.url;
          cta.firstChild.textContent = button.dataset.label + ' ';
        };
        buttons.forEach(button => button.addEventListener('click', () => select(button)));
        if (buttons.length) select(buttons[0]);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hlg-then-now"] && !Shopify.designMode) return;
  try {
    
/* Previous / Next through the checked then-and-now pairs (25 Oct 2026, Darren: "no option to see more").
   Each pair's two products are read from /products/<handle>.js; a pair with either print off sale is skipped. */
if (!customElements.get('hlg-then-now-pairs')) {
  customElements.define('hlg-then-now-pairs', class extends HTMLElement {
    connectedCallback() {
      try { this.pairs = JSON.parse(this.querySelector('[data-tn-pairs]').textContent); } catch (e) { return; }
      if (!this.pairs || this.pairs.length < 2) return;
      this.index = parseInt(this.dataset.start, 10) || 0;
      this.cache = {};
      this.nav = this.querySelector('[data-tn-nav]');
      this.count = this.querySelector('[data-tn-count]');
      this.nav.hidden = false;
      this.nav.addEventListener('click', (e) => {
        const b = e.target.closest('[data-tn-step]');
        if (b) this.step(parseInt(b.dataset.tnStep, 10));
      });
      this.showCount();
    }
    showCount() {
      this.count.textContent = this.dataset.count.replace('%n%', this.index + 1).replace('%total%', this.pairs.length);
    }
    product(handle) {
      if (!this.cache[handle]) {
        this.cache[handle] = fetch(this.dataset.root + 'products/' + encodeURIComponent(handle) + '.js')
          .then((r) => (r.ok ? r.json() : null)).catch(() => null);
      }
      return this.cache[handle];
    }
    async ready(pair) {
      const [t, n] = await Promise.all([this.product(pair.then), this.product(pair.now)]);
      return t && n && t.available && n.available && t.featured_image && n.featured_image ? [t, n] : null;
    }
    async step(dir) {
      if (this.busy) return;
      this.busy = true;
      this.setAttribute('aria-busy', 'true');
      this.nav.querySelectorAll('button').forEach((b) => (b.disabled = true));
      let i = this.index;
      let found = null;
      for (let tries = 0; tries < this.pairs.length - 1 && !found; tries++) {
        i = (i + dir + this.pairs.length) % this.pairs.length;
        const prods = await this.ready(this.pairs[i]);
        if (prods) found = prods;
      }
      if (found) {
        this.index = i;
        this.render(this.pairs[i], found);
        this.showCount();
        const next = this.pairs[(i + dir + this.pairs.length) % this.pairs.length];
        this.ready(next);
      }
      this.busy = false;
      this.removeAttribute('aria-busy');
      this.nav.querySelectorAll('button').forEach((b) => (b.disabled = false));
    }
    setImage(img, product) {
      const src = product.featured_image.startsWith('//') ? 'https:' + product.featured_image : product.featured_image;
      const join = src.includes('?') ? '&' : '?';
      img.srcset = [500, 800, 1000].map((w) => src + join + 'width=' + w + ' ' + w + 'w').join(', ');
      img.src = src + join + 'width=1000';
      img.alt = product.title;
      img.removeAttribute('width');
      img.removeAttribute('height');
    }
    render(pair, [t, n]) {
      this.setImage(this.querySelector('.hlg-then-now__half--then img'), t);
      this.setImage(this.querySelector('.hlg-then-now__half--now img'), n);
      this.querySelector('[data-tn-then-cap]').textContent = this.dataset.thenCaption.replace('%place%', pair.place).replace('%year%', pair.year);
      this.querySelector('[data-tn-now-cap]').textContent = this.dataset.nowCaption.replace('%place%', pair.place);
      const link = this.querySelector('[data-tn-link]');
      link.href = this.dataset.root + 'collections/prints-of-' + pair.handle;
      link.setAttribute('aria-label', this.dataset.both + ': ' + pair.place);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["msp-hero-editorial"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('msp-location-hero')) {
    customElements.define('msp-location-hero', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.slides = [...this.querySelectorAll('[data-slide]')];
        if (!this.slides.length) return;
        this.index = 0;
        this.requestId = 0;
        this.manualPause = false;
        this.visible = true;
        this.reduced = matchMedia('(prefers-reduced-motion:reduce)');
        this.toggle = this.querySelector('[data-pause-toggle]');
        this.querySelectorAll('[data-step]').forEach(control => {
          control.hidden = this.slides.length < 2;
          control.addEventListener('click', () => this.show((this.index + Number(control.dataset.step) + this.slides.length) % this.slides.length, true), options);
        });
        this.toggle.hidden = this.slides.length < 2;
        this.toggle.addEventListener('click', () => { this.manualPause = !this.manualPause; this.schedule(); }, options);
        this.addEventListener('focusin', () => this.schedule(), options);
        this.addEventListener('focusout', () => queueMicrotask(() => this.schedule()), options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.reduced.addEventListener('change', () => this.schedule(), options);
        this.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.slide === event.detail.blockId);
          if (index >= 0) this.show(index, true);
        }, options);
        const visual = this.querySelector('.msp-editorial__visual');
        visual.addEventListener('pointerdown', event => { this.swiped = false; if (event.pointerType === 'touch') this.start = [event.clientX, event.clientY]; }, options);
        visual.addEventListener('pointerup', event => {
          if (!this.start) return;
          const dx = event.clientX - this.start[0], dy = event.clientY - this.start[1];
          this.start = null;
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
            this.swiped = true;
            this.show((this.index + (dx < 0 ? 1 : this.slides.length - 1)) % this.slides.length, true);
          }
        }, options);
        visual.addEventListener('pointercancel', () => { this.start = null; }, options);
        visual.addEventListener('click', event => { if (this.swiped) { event.preventDefault(); this.swiped = false; } }, options);
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); });
        this.observer.observe(this);
        // The next slide's artwork, once the page itself has finished loading.
        const warm = () => this.hydrate(1);
        if (document.readyState === 'complete') setTimeout(warm, 1500);
        else window.addEventListener('load', () => setTimeout(warm, 1500), { once: true, signal: this.abort.signal });
        this.schedule();
      }
      hydrate(index) {
        const img = this.slides[index]?.querySelector('img');
        if (!img || !img.dataset.src) return;
        img.srcset = img.dataset.srcset || '';
        img.src = img.dataset.src;
        delete img.dataset.src;
        delete img.dataset.srcset;
      }
      schedule() {
        clearTimeout(this.timer);
        const stopped = this.manualPause || this.reduced.matches;
        this.toggle.textContent = stopped ? this.dataset.play : this.dataset.pause;
        this.toggle.hidden = this.slides.length < 2 || this.reduced.matches;
        const keyboardFocus = document.activeElement !== this.toggle && this.contains(document.activeElement) && document.activeElement?.matches(':focus-visible');
        if (!stopped && this.visible && !document.hidden && !keyboardFocus && this.slides.length > 1) {
          this.timer = setTimeout(() => this.show((this.index + 1) % this.slides.length, false), 6000);
        }
      }
      async show(index, manual) {
        clearTimeout(this.timer);
        const token = ++this.requestId;
        const slide = this.slides[index];
        this.hydrate(index);
        this.hydrate((index + 1) % this.slides.length);
        try { await slide.querySelector('img').decode(); } catch { this.schedule(); return; }
        if (token !== this.requestId || !this.isConnected) return;
        this.index = index;
        this.slides.forEach((item, i) => {
          item.classList.toggle('is-active', i === index);
          item.setAttribute('aria-hidden', String(i !== index));
          item.tabIndex = i === index ? 0 : -1;
        });
        const contexts = [...this.querySelectorAll('[data-context]')];
        const caption = contexts.find(item => item.dataset.context === slide.dataset.slide)?.dataset.caption || slide.dataset.label;
        const shop = this.querySelector('[data-shop]');
        shop.href = slide.href;
        shop.textContent = caption + ' →';
        this.querySelectorAll('[data-source-for]').forEach(item => { item.hidden = item.dataset.sourceFor !== slide.dataset.slide; });
        if (manual) this.querySelector('[data-status]').textContent = slide.dataset.label;
        this.schedule();
      }
      disconnectedCallback() { clearTimeout(this.timer); this.abort?.abort(); this.observer?.disconnect(); this.requestId++; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["msp-studio-styles"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('msp-style-preview')) {
    customElements.define('msp-style-preview', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.buttons = [...this.querySelectorAll('button[aria-controls]')];
        this.panels = [...this.querySelectorAll('.msp-studio-styles__item')];
        this.selected = 0;
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.refresh = () => {
          this.buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === this.selected)));
          this.panels.forEach((panel, i) => { panel.hidden = this.mobile.matches && i !== this.selected; });
        };
        this.buttons.forEach((button, i) => button.addEventListener('click', () => { this.selected = i; this.refresh(); }, { signal:this.controller.signal }));
        this.mobile.addEventListener('change', this.refresh, { signal:this.controller.signal });
        this.addEventListener('shopify:block:select', event => {
          const index = this.panels.findIndex(panel => panel === event.target || panel.contains(event.target));
          if (index >= 0) { this.selected = index; this.refresh(); }
        }, { signal:this.controller.signal });
        this.dataset.ready = '';
        this.refresh();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
